import { Claim } from './../../_models/claim';
import { Directive, Input, HostBinding } from '@angular/core';

@Directive({
    selector: '[possuiClaim]'
})
export class PossuiClaimDirective {

    @HostBinding('style.display') private display;

    @Input() set possuiClaim(claim: any) {
        const tagClaims: any = JSON.parse(claim);
        const userClaims: Array<Claim> = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["claims"];
        if (userClaims) {
            if (!userClaims.some(x => x.tipo === tagClaims.tipo && x.acoes.some(y => y.nomeAcao === tagClaims.nomeAcao))) {
                this.display = 'none';
            }
        }
    }

    public constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/possui-claim.directive.ts